<template>
<div class="background-supplement-no-title-layout">
    <div class="layout-content course-video">
        <div class="header">
            <p class="video-sum">共有视频回放: {{ playbackInfo.total || 0 }}</p>
            <el-select
                v-model="filterType"
                class="selector"
                placeholder="请选择"
                @change="onChangeSelect">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="card-list" v-for="(arr, index) in currentPlaybacksByRow" :key="index">
            <VideoCard
                v-for="(item, index) in arr"
                :key="item.sessionId"
                :item="item"
                :is-middle="index === 1"></VideoCard>
        </div>
        <!-- 分页 -->
        <div class="playback-pagination">
            <el-pagination
                v-if="showPagination"
                class="handler"
                :page-size="pageSize"
                :current-page.sync="currentPage"
                @current-change="onPageChange"
                layout="prev, pager, next"
                :total="playbackInfo.total">
            </el-pagination>
        </div>
    </div>
</div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import VideoCard from './CourseVideoCard';

export default {
    components: { VideoCard },
    data() {
        return {
            playbackInfo: {
                total: 0,
                playbacks: []
            },
            filterType: 0,
            options: [
                {
                    value: 0,
                    label: '全部'
                },
                {
                    value: Enums.LessonType.FREE_LESSON,
                    label: '试听课'
                },
                {
                    value: Enums.LessonType.FORMAL_LESSON,
                    label: '正式课'
                },
                {
                    value: Enums.LessonType.QA_LESSON,
                    label: '答疑课'
                }
            ],
            // 分页
            currentPage: 1,
            pageSize: 9

        };
    },
    computed: {
        showPagination() {
            return this.playbackInfo.total / this.pageSize > 1;
        },
        currentPlaybacksByRow() {
            return _.chunk(this.playbackInfo.playbacks, 3);
        }
    },
    beforeMount() {
        this.getPlaybackInfo({ limit: this.pageSize });
    },
    methods: {
        /**
         * 获取回放列表
         * @params: params: API调用涉及到的数据：
         * {
         *      types: '1,2',   // 【可选】课程类型 enum#LessonType;如果没有该字段则认为筛选所有课程类型;字符串，如果为多个类型用英文逗号分隔
                start: 0,       // 【可选】翻页开始条目 默认0
                limit: 10,      // 【可选】每页数目 默认10
            }
         * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=80543837#hfsfd-be%E5%9B%9E%E6%94%BE%EF%BC%88%E8%BF%9E%E7%BA%BF%EF%BC%89API-%E8%8E%B7%E5%8F%96%E5%9B%9E%E6%94%BE%E5%88%97%E8%A1%A8%E3%80%90WIP%E3%80%91
         */
        fetchPlaybackInfo(params) {
            return this.$http.get('/v1/playbacks/list', { params })
                .then(resp => this.$checkResp(resp, null));
        },
        getPlaybackInfo: _.debounce(function(params) {
            this.fetchPlaybackInfo(params)
                .then(data => {
                    this.handlePlaybackInfo(data);
                })
                .catch(err => {
                    this.$handleError(err);
                });
        }, 20),
        // 对API返回的数据预处理
        handlePlaybackInfo(data) {
            if (data) {
                data.playbacks.forEach(item => {
                    let startTimeStr = moment(item.startTime).format('YYYY-MM-DD HH:mm');
                    let endTimeStr = moment(item.endTime).format('HH:mm');
                    item.periodStr = `上课时间： ${startTimeStr} ~ ${endTimeStr}`;

                    switch (item.type) {
                    case Enums.LessonType.FREE_LESSON:
                        item.typeStr = '试听';
                        break;
                    case Enums.LessonType.FORMAL_LESSON:
                        item.typeStr = '正式';
                        break;
                    case Enums.LessonType.QA_LESSON:
                        item.typeStr = '答疑';
                        break;
                    }
                });
            } else {
                data = {
                    total: 0,
                    playbacks: []
                };
            }
            this.playbackInfo = data;
        },
        // 分页跳转处理函数
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            let params = {
                start: (currentPage - 1) * this.pageSize,
                limit: this.pageSize
            };
            // 除非是 0 （全部types），否则需要设置types
            if (this.filterType) {
                params.types = this.filterType;
            }
            this.getPlaybackInfo(params);
        },
        // 下拉菜单变更处理函数
        onChangeSelect(type) {
            this.filterType = type;
            this.currentPage = 1;
            let params = {
                start: 0,
                limit: this.pageSize
            };
            // 除非是 0 （表示全部types），否则需要设置types
            if (this.filterType) {
                params.types = this.filterType;
            }
            this.getPlaybackInfo(params);
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.course-video {
    display: flex;
    flex-direction: column;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12.5px;

    .video-sum {
        font-size: 16px;
        color: #333;
    }

    .selector {
        border-radius: 2px;
        width: 120px;
        height: 36px;
    }
}

// -----------------卡片部分---------------
.card-list {
    display: flex;
}

// ---------------分页--------------------
.playback-pagination {
    display: flex;
    justify-content: center;
    flex: 1;

    .handler {
        margin: 17px 0 0;
        align-self: flex-end;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/CourseVideo.vue